import React, { useState } from 'react';
import styles from './SystemDetails.module.css';
import {
  ResponsiveContainer,
  BarChart,
  YAxis,
  Tooltip,
  XAxis,
  Bar
} from 'recharts';
import { SENSORS } from '../../config';
import SensorToGraphPicker from '../SharedGraphs/SensorToGraphPicker';
import { findHighestAndLowestReadingsFromSensor } from '../../utils/sensorHelpers';
import CenteredSpinner from '../Shared/CenteredSpinner';
import { useLastMetrics } from '../../hooks/useLastMetrics';
import { useTranslation } from 'react-i18next';

function LastReadingBartChart({ systemId, barHeight }) {
  const { t } = useTranslation();
  const { lastMetrics, loading, error } = useLastMetrics(systemId);
  const [selectedSensor, setSelectedSensor] = useState(SENSORS.Voltage);
  let sensors = [SENSORS.Voltage, SENSORS.InternalResistance];

  const data = [];
  const sensorIds = [];

  const { highest, lowest } = findHighestAndLowestReadingsFromSensor(
    5,
    lastMetrics,
    selectedSensor
  );

  [lowest, highest].forEach((array) => {
    data.push.apply(
      data,
      array.map((reading) => ({
        name: reading.deviceSensorId,
        value: reading.value
      }))
    );
    sensorIds.push.apply(
      sensorIds,
      array.map((reading) => reading.deviceSensorId)
    );
  });

  const loadingOrError = loading ? (
    <CenteredSpinner />
  ) : (
    <h3 className={styles.errorText}>{t('failure')}</h3>
  );

  return (
    <div className={styles.lastReadingBarChartCard}>
      <p className={styles.sensorExplainerText}>
        {t('fiveLargestAndSmallestRightNow')}
      </p>
      <SensorToGraphPicker
        sensors={sensors}
        selectedSensor={selectedSensor}
        onSensorClicked={setSelectedSensor}
      />
      <div style={{ height: barHeight }}>
        {loading || error ? (
          loadingOrError
        ) : (
          <ResponsiveContainer width={'99%'} height={'100%'}>
            <BarChart data={data}>
              <XAxis dataKey="name" />
              <YAxis
                domain={['dataMin', 'dataMax']}
                unit={selectedSensor.unit}
                tickFormatter={(value) => Math.round(value * 100) / 100}
              />
              <Tooltip />
              <Bar dataKey={'value'} fill="#8884d8" />
            </BarChart>
          </ResponsiveContainer>
        )}
      </div>
    </div>
  );
}

export default LastReadingBartChart;
